import { useState } from "react";

export function InkHero({ image }) {
  const [videoOk, setVideoOk] = useState(true);
  return (
    <div className="absolute inset-0 overflow-hidden">
      {/* clear tattoo image */}
      <div className="kenburns absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover opacity-[0.62]" />
      </div>

      {/* very subtle ink motion (no screen-blend so it doesn't look like smoke) */}
      {videoOk && (
        <video
          autoPlay muted loop playsInline poster={image}
          onError={() => setVideoOk(false)}
          className="absolute inset-0 w-full h-full object-cover opacity-[0.16]"
        >
          <source src="https://assets.mixkit.co/videos/152/152-720.mp4" type="video/mp4" />
        </video>
      )}

      {/* legibility + mood: dark left + dark bottom, purple only */}
      <div className="absolute inset-0 bg-gradient-to-r from-obsidian via-obsidian/70 to-obsidian/25" />
      <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-transparent to-obsidian/50" />
      <div className="ink-blob ink-2" />
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='120'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")" }} />
    </div>
  );
}
